import angular from 'angular';

import MailToDirective, { selector } from './mail-to.directive';

export default angular.module('common.directive.mail-to', [])
    .directive(selector, MailToDirective);



// WEBPACK FOOTER //
// ./src/common/directive/mail-to/index.js